import { takeLatest, put, call, select } from 'redux-saga/effects';
import {
  OPEN_ANNUAL_REVIEW_REPORT,
  FETCH_ANNUAL_REVIEW_REPORT,
  setAnnualReviewReportData,
  setAnnualReviewReportLoading,
  setAnnualReviewReportDateRange,
  annualReviewReportSelector,
} from '../actions';
import { POPUP_ALERT } from '../../../actions/alert';
import fetchAnnualReviewReportApi from '../../../api/annualReviewReport';
import {
  getDefaultPeriodRange,
  getPeriodQueryParams,
  normalizePeriodRange,
} from '../periodUtils';

const DEFAULT_ERROR_MESSAGE = 'Error fetching annual review report.';

function* fetchReport(hubId, dateRange) {
  const range = normalizePeriodRange(dateRange) || getDefaultPeriodRange();
  const params = getPeriodQueryParams(range) || {};
  if (!hubId) {
    return;
  }
  try {
    yield put(setAnnualReviewReportDateRange(range));
    yield put(setAnnualReviewReportLoading(true));
    const { data: reportData } = yield call(
      fetchAnnualReviewReportApi,
      hubId,
      params
    );
    yield put(setAnnualReviewReportData(reportData));
  } catch (error) {
    yield put({
      type: POPUP_ALERT,
      data: {
        type: 'error',
        message: error?.response?.data?.message || DEFAULT_ERROR_MESSAGE,
      },
    });
  } finally {
    yield put(setAnnualReviewReportLoading(false));
  }
}

function* openAnnualReviewReportSaga({ data }) {
  yield* fetchReport(data?.hubId, getDefaultPeriodRange());
}

function* fetchAnnualReviewReportSaga({ data }) {
  const state = yield select(annualReviewReportSelector);
  const hubId = data?.hubId || state?.selectedHubId;
  const dateRange = data?.dateRange || state?.dateRange;
  yield* fetchReport(hubId, dateRange);
}

const sagas = [
  takeLatest(OPEN_ANNUAL_REVIEW_REPORT, openAnnualReviewReportSaga),
  takeLatest(FETCH_ANNUAL_REVIEW_REPORT, fetchAnnualReviewReportSaga),
];

export default sagas;
